import { gql } from '@apollo/client';

export const QUERY_GET_USER_PREFERENCES = gql`
    query GetUserPreferences($componentKey: String!, $recordTypeId: Float) {
        getUserPreferences(componentKey: $componentKey, recordTypeId: $recordTypeId) {
            componentKey
            id
            isDefault
            name
            preferenceData
        }
    }
`;
